import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Link } from '$components/elements/link';
import { IEnrichedThemaCode } from '$models';
type IProductThemaProps = {
    themaCodes: IEnrichedThemaCode[][];
};

export const ProductThemas: FC<IProductThemaProps> = ({ themaCodes }: IProductThemaProps): JSX.Element => {
    return (
        <>
            {!!themaCodes?.length && (
                <>
                    <ThemaCodesContainer>
                        {themaCodes.map((breadCrumbs: IEnrichedThemaCode[], index: number) => (
                            <BreadCrumb key={index}>
                                {breadCrumbs.map((breadCrumb: IEnrichedThemaCode, index: number) => (
                                    <Link key={`${breadCrumb.code}-${index}`} href={breadCrumb.url || ''}>
                                        <span>
                                            <BreadCrumbText>{`${breadCrumb.title}`}</BreadCrumbText>
                                            {index < breadCrumbs.length - 1 && <BreadCrumbDivider />}
                                        </span>
                                    </Link>
                                ))}
                            </BreadCrumb>
                        ))}
                    </ThemaCodesContainer>
                </>
            )}
        </>
    );
};

const ThemaCodesContainer = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes.sm,
}));

const BreadCrumb = styled.li(({ theme }) => ({
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    borderBottom: `1px solid ${theme.colors.primaryGreyLight}`,
    padding: `${theme.space[3]} 0`,
    ':first-child': {
        paddingTop: 0,
    },
}));

const BreadCrumbText = styled.span(({ theme }) => ({
    color: theme.colors.red,
    cursor: 'pointer',

    '&:hover': {
        textDecoration: 'underline',
    },
}));

const BreadCrumbDivider = styled.span(({ theme }) => ({
    '&:after': {
        content: '">"',
        margin: '0px',
        padding: `0 ${theme.space[2]}`,
        color: theme.colors.red,
    },
}));
